import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {FloatingTypes} from './getFloatingTypes'

export interface IFloating {
    id?: string
    start_at: number
    end_at: number
    priority: number
    language?: string
    title?: string
    filter?: {
        [key in FloatingTypes]: any // any 대신 원하는 값의 타입을 지정하세요.
    }
    text?: any
    emoji?: string
    action_url?: any
    button_url?: {
        web_ko?: string
        web_en?: string
        app_ko?: string
        app_en?: string
    }
    button_text?: any
}

export const getFloatings = async (active: boolean): Promise<ApiRes<IFloating[]>> => {
    return await apiGet(API_URL, `admin/floating/messages?active=${active}`)
}
